import Vuex from 'vuex'
import Vue from 'vue'

import actions from './actions'
import getters from './getters'
import mutations from './mutations'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    loaded: false,
    allowSuggestions: false,
    offline: undefined,
    frontend: [],
    rounds: [],
    categories: [],
    nominees: [],
    selected: [],
    votes: [],
    showtimesTags: ['ochtend', 'middag', 'avond', 'nacht', 'weekend'],
    stationsTags: []
  },
  actions,
  getters,
  mutations
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js